




































































import { Vue, Component } from "vue-property-decorator";

import BaseForm from "@/components/Base/Form/BaseForm.vue";
import InputControl from "@/components/Controls/InputControl.vue";

import validations from "./validations";

@Component({
  components: {
    InputControl
  },
  extends: BaseForm,
  validations
})
export default class UserLoginForm extends Vue {
  public formUrl = `${process.env.VUE_APP_XHR_ROOT}/disclosurecode/user/login/`;
  public labelClass = "col-form-label col-md-3 form__label";
  public controlClass = "col-md-9 form__control";
  public descriptionClass = "offset-md-3 col-md-9 form__control-description";
  public forgotten = false;

  public login = {
    username: "",
    password: ""
  };

  public formName = "login";

  afterSubmit(res: any) {
    if (res.data.success) {
      Promise.all([
        this.$store.dispatch("User/getCurrent"),
        this.$store.dispatch("App/getConfig")
      ]).then(() => this.$router.push("/"));
    }
  }
}
